var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import styles from './TooltipSimple.module.css';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function TooltipSimple(_a) {
    var text = _a.text, style = _a.style, inputBaseStyle = _a.inputBaseStyle, _b = _a.closeOnOutsideClick, closeOnOutsideClick = _b === void 0 ? false : _b, _c = _a.closeOnScroll, closeOnScroll = _c === void 0 ? false : _c, key = _a.key;
    var _d = __read(useState(false), 2), isVisible = _d[0], setIsVisible = _d[1];
    var _e = __read(useState(window.innerWidth), 2), windowWidth = _e[0], setWindowWidth = _e[1];
    var tooltipRef = useRef(null);
    useEffect(function () {
        if (tooltipRef.current) {
            var handleClose_1 = function (_a) {
                var target = _a.target;
                if (tooltipRef.current &&
                    !tooltipRef.current.contains(target)) {
                    setIsVisible(false);
                }
            };
            if (closeOnOutsideClick) {
                document.addEventListener('click', handleClose_1);
            }
            if (closeOnScroll) {
                window.addEventListener('scroll', handleClose_1);
            }
            return function () {
                document.removeEventListener('click', handleClose_1);
                window.removeEventListener('scroll', handleClose_1);
            };
        }
    }, [tooltipRef.current]);
    useEffect(function () {
        var handleResize = function () {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var delimiter = '&';
    var textArray = text.split(delimiter);
    var maxLengthLine = function () {
        var maxLine = 0;
        textArray.forEach(function (line) {
            if (line.length > maxLine)
                maxLine = line.length;
        });
        return maxLine;
    };
    var dynamicWidth = Math.round(maxLengthLine() * 6.1) + 20;
    var plateStyle = { width: "".concat(dynamicWidth, "px") };
    var plateСontainerStyle = {
        opacity: isVisible ? 100 : 0
    };
    var arrowStyle = {};
    if (windowWidth > 1140) {
        plateСontainerStyle.right = "".concat(30 - dynamicWidth, "px");
        arrowStyle.marginRight = "".concat(dynamicWidth - 29, "px");
    }
    else if (windowWidth > 900 && windowWidth <= 1140) {
        plateСontainerStyle.right = "".concat(6 - dynamicWidth / 2, "px");
        arrowStyle.marginRight = "".concat(dynamicWidth / 2 - 5, "px");
    }
    else if (inputBaseStyle) {
        plateСontainerStyle.right = '0px';
        arrowStyle.marginRight = '3px';
    }
    else {
        plateСontainerStyle.right = '-18px';
        arrowStyle.marginRight = '20px';
    }
    function replaceAndWithLineBreak(text) {
        var replacedText = text.replace(/ & /g, '\n');
        return replacedText;
    }
    return (React.createElement("div", { className: styles.tooltip, ref: tooltipRef, key: key, style: __assign({}, style) },
        React.createElement("button", { type: 'button', className: styles.button, onClick: function () { return setIsVisible(function (prev) { return !prev; }); } }),
        React.createElement("section", { className: styles.plateContainer, style: plateСontainerStyle },
            React.createElement("div", { className: styles.plate, style: plateStyle },
                React.createElement("textarea", { className: styles.plateText, rows: textArray.length, value: replaceAndWithLineBreak(text), disabled: true })),
            React.createElement("div", { className: styles.arrow, style: arrowStyle }))));
}
